<template>
  <div>
    <DxPopup
      :visible="popupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      :width="'75%'"
      :height="'75%'"
      title="Kit Component Definition"
      @hidden="popupHidden"
      @shown="popupShown"
      :showCloseButton="false"
      :wrapperAttr="{ class: 'css-v2 gc-popup gc-popup-product-kits' }"
    >
      <GcProductKits
        :contentHeight="popupContentHeight"
        :data-model="model"
        :ref="'gc-product-kits'"
        :productKitDetails="productKitDetails"
        :allowToSave="allowToSave"
      />

      <div class="footer">
        <DxButton
          :text="'Save'"
          type="success"
          styling-mode="contained"
          :disabled="!enableSave"
          @click="onSave"
        />
        <DxButton
          :text="'Cancel'"
          type="default"
          styling-mode="contained"
          @click="popupHidden"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
export default {
  props: {
    setVisible: Boolean,
    callBack: {
      type: Function,
      default: function () {},
    },
    model: {
      type: Object,
      default: () => {},
    },
    productKitDetails: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [],
  data() {
    return {
      popupContentHeight: undefined,
      enableSave: false,
    };
  },
  async created() {},
  computed: {
    popupVisible() {
      return this.setVisible ? true : false;
    },
  },
  watch: {},
  methods: {
    allowToSave(value) {
      this.enableSave = value;
    },
    popupHidden() {
      this.$refs["gc-product-kits"].getDataModels().then((res) => {
        if (res != false) this.callBack(false, res);
        else this.callBack(false, false);
      });
    },
    popupShown() {
      let popupContentArea = document.querySelector(
        ".gc-popup-product-kits .dx-overlay-content"
      );
      if (popupContentArea)
        this.popupContentHeight = popupContentArea.clientHeight;
    },
    onSave() {
      this.$refs["gc-product-kits"].getDataModels().then((res) => {
        if (res != false) this.callBack(true , res);
      });
    },
  },
};
</script>

<style lang="scss">
.gc-popup-product-kits {
  .footer {
    position: absolute;
    width: 100%;
    padding-top: 10px;
    bottom: 0;
    height: 45px;
    text-align: right;

    display: flex;
    flex-direction: row;
    justify-content: flex-end !important;

    .dx-button {
      display: flex;
      justify-content: center;
      flex-grow: 1;
      margin-right: 5px;
      flex-grow: unset !important;
    }
    .dx-button:last-child {
      margin-right: 0px;
    }
  }
}
</style>
